import $ from 'jquery'
import _ from 'lodash'
import selects from 'scoreboard/components/selects'
import ImagePicker from 'scoreboard/components/image-picker'
import projects from 'scoreboard/projects/projects'

/**
 * A project selector with projects dropdown (scoreboard-select)
 *
 * @param {JQuery|Element} el The select element
 * @param {Object[]} [options.projects=projects.asArray()] The projects to show
 * @param {Number} [options.projectId=projects.id] The project to preselect
 */
function renderProjectDropdown(el, options={}) {
	const projectList = options.projects || projects.asArray()
	const projectId = options.projectId || projects.selectedOrFirstId()
	selects(el, {
		options: _.map(projectList, p => {
			return {
				orgId: p.orgId,
				label: p.label,
				value: p.id,
				selected: p.id == projectId,
				img: ImagePicker.imgSrc(p.logoFileId, projects.LOGO)
			}
		}),
		render: {
			itemBefore: function (d) {
				return `
					<div class="project-image-container">
						<img class="project-image" src="${_.get(_.find(d.menuOptions, o => o.selected), 'img')}">
					</div>
				`
			},
			option: function(d) {
				return `
					<div class="project-image-container">
						<img class="project-image" src="${d.img}">
					</div>
					<span class="label">${d.label}</span>
				`
			}
		}
	})
}

/** Get the Project model from a selected value event */
function selectedProject (event) {
	projects.get($(event.target).val())
}

_.extend(renderProjectDropdown, {
	selectedProject
})

export default renderProjectDropdown
export { selectedProject }

renderProjectDropdown.__filename__ = 'projects/render-project-dropdown.js'
